<template>
    <DFormRow
        :label="__('customers.contracts.term_and_condition_version')"
        :is-required="required"
        :error="errors.terms_and_conditions_id"
    >
        <DSelect
            id="terms_and_conditions"
            :model-value="modelValue"
            :options="termsAndConditions"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'TermsAndConditions',
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        modelValue: {
            type: [String, Number],
            default: null
        },
        required: {
            type: Boolean,
            default: () => { return true }
        },
        termsAndConditions: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['update:modelValue']
}
</script>
